import { Center, Container, Heading } from 'native-base'

const MobileRoom = () => {
  return (
    <Center height={'full'}>
      <Container>
        <Heading>Live Group Room 3.0</Heading>
        <Heading size={'md'}>Mobile</Heading>
      </Container>
    </Center>
  )
}

export default MobileRoom
